import React from 'react';

// eslint-disable-next-line react/prop-types
function TwPageContentContainer({ children, classList }) {
  return <div className={`flex flex-col w-full ${classList}`}>{children}</div>;
}

export default TwPageContentContainer;
